import { Injectable } from '@angular/core';
import { ReCaptchaService } from '@app/core/recaptcha/re-captcha.service';
import { MemberIdentifier } from '@app/core/_models/member-interface';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { MemberService } from '@app/core/members/member.service';
import { RecaptchaAction, RecaptchaData } from '@app/core/recaptcha/recaptcha-commons';

@Injectable({
  providedIn: 'root',
})
export class MsisdnRegisterOtpService {
  constructor(private reCaptchaService: ReCaptchaService,
              private memberService: MemberService,
  ) {}

  /**
   * If recaptcha score will be too low it will throw TooLowRecaptchaScoreError
   * which will indicate that checkbox captcha should be used instead
   */
  public generateOTP(identifier: MemberIdentifier | undefined): Observable<unknown> {
    return this.generateScoreBasedReCaptchaKey()
      .pipe(
        switchMap(captchaData => this.sendOTP(identifier, captchaData)),
      );
  }

  public generateOTPWithCheckboxData(identifier: MemberIdentifier | undefined, data: RecaptchaData): Observable<unknown> {
    return this.sendOTP(identifier, data);
  }

  private generateScoreBasedReCaptchaKey(): Observable<RecaptchaData> {
    return this.reCaptchaService
      .generateToken(RecaptchaAction.register);
  }

  private sendOTP(identifier: MemberIdentifier | undefined, data: RecaptchaData): Observable<unknown> {
    return this.memberService.sendRegistrationPassword(identifier, data);
  }
}
